import React from "react";
import userprofile from "../assets/images/user_profile.png";
import dropdown from "../assets/images/dropdown.png";
import Dropdown from "react-bootstrap/Dropdown";

import Shop from "../assets/images/shop.png";
import Menu from "../assets/images/menu.png";

function HeaderRight(props) {
  return (
    <>
      <header>
        <div class="custom_container ">
          {/*  <div class="login_logo  mb_40">
              <button
                style={{
                  backgroundColor: "white",
                  marginRight: 20,
                  borderWidth: 0,
                }}
                onClick={() => navigate(-1)}
              >
                <img src={Left} alt="" />{" "}
              </button>
              <img src={logo} alt="" />{" "}
            </div> */}
          <div class="user_profile">
            <div class="collapse navbar-collapse show" id="navbar-list-4">
              <ul class="navbar-nav d-flex     flex-row align-items-center">
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img src={userprofile} class="mr-3" />
                  </a>
                </li>

                <Dropdown>
                  <Dropdown.Toggle>
                    <img src={dropdown} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    aria-labelledby="navbarDropdownMenuLink "
                    className="dropdown-menu"
                    style={{ marginLeft: -200 }}
                  >
                    <Dropdown.Item
                      // className="dropdown-item"
                      href="/editProfile"
                    >
                      <a class="dropdown-item">Edit Profile </a>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      ClassName="dropdown-item"
                      href="/accountSettings"
                    >
                      <a class="dropdown-item">Account Setting</a>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item ClassName="dropdown-item" href="/wallet">
                      <a class="dropdown-item">
                        Wallet
                      </a>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item ClassName="dropdown-item" href="/logout">
                      <a class="dropdown-item" >
                        Logout
                      </a>{" "}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </ul>
            </div>
          </div>
        </div>
      </header>
      {/*  <div class="collapse navbar-collapse show" id="navbar-list-4">
        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src={userprofile}
                class="user_profile_img"
              />
              <img
                src={dropdown}
                class="ml-2 user_profile_icon"
              />{" "}
            </a>
            <div
              class="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >
              {" "}
              <a class="dropdown-item" href="#">
                Edit Profile{" "}
              </a>{" "}
              <a class="dropdown-item" href="#">
                Account Setting
              </a>
              <a class="dropdown-item" href="#">
                Wallet
              </a>{" "}
              <a class="dropdown-item" href="#">
                Logout
              </a>{" "}
            </div>
          </li>
        </ul>
      </div> */}
    </>
  );
}

export default HeaderRight;
